export default [
  {
    path: '/v2/invoice-adjustment',
    name: 'v2-invoice-adjustment-create',
    meta: { requiresAuth: true },
    component: () => import('./views/create.vue')
  },
  {
    path: '/v2/invoice-adjustment/:id',
    name: 'v2-invoice-adjustment-show',
    meta: { requiresAuth: true },
    component: () => import('./views/show.vue')
  }
]
